"use strict";const r=require("./index18.js"),t=require("./index249.js");var x=r._export,e=t.regexpExec;x({target:"RegExp",proto:!0,forced:/./.exec!==e},{exec:e});
